export enum EncryptionMethod {
  RSA = "RSA",
  SessionSecured = "SessionSecured",
  Legacy = "Legacy",
}
